import script from "./DemandForecastingMixins.vue?vue&type=script&lang=js"
export * from "./DemandForecastingMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__